module.exports = __webpack_public_path__ + "img/cancel icon.1ec478c6.svg";